import { Reducer } from 'redux';
import { TripsState, TripTypes } from './types';

const INITIAL_STATE: TripsState = {
  tripData: {
    id: '',
    title: '',
    status: 0,
    approvalStatus: 0,
    startedAt: '',
    closedAt: '',
    km: 0,
    idleKm: 0,
    TripOccurrences: [],
    TripMetrics: [],
    TripControl: {
      id: '',
      startKm: 0,
      startKmPhoto: '',
      endKm: 0,
      endKmPhoto: '',
      resultKm: 0,
      startEntryCount: 0,
      startEntryCountPhoto: '',
      endEntryCount: 0,
      endEntryCountPhoto: '',
      resultEntryCount: 0,
      startExitCount: 0,
      startExitCountPhoto: '',
      endExitCount: 0,
      endExitCountPhoto: '',
      resultExitCount: 0,
      createdAt: '',
      updatedAt: '',
      tripId: '',
      employeeId: '',
      lineSectionId: '',
    },
    createdAt: '',
    updatedAt: '',
    employeeId: null,
    lineSectionId: null,
    dbdId: null,
    carId: null,
    blockId: null,
    transportOperatorId: '',
    tripDataUrl: null,
    TripSchedule: null,
  },
  tripReportControl: {
    startKm: 0,
    startKmPhoto: '',
    endKm: 0,
    endKmPhoto: '',
    resultKm: 0,
    startEntryCount: 0,
    startEntryCountPhoto: '',
    endEntryCount: 0,
    endEntryCountPhoto: '',
    resultEntryCount: 0,
    startExitCount: 0,
    startExitCountPhoto: '',
    endExitCount: 0,
    endExitCountPhoto: '',
    resultExitCount: 0,
    id: '',
    createdAt: '',
    lineSectionId: '',
    tripId: '',
    updatedAt: '',
    employeeId: '',
  },
  tripControlSettingsData: {
    id: '',
    startKm: 0,
    startKmPhoto: 0,
    endKm: 0,
    endKmPhoto: 0,
    startEntryCount: 0,
    endEntryCount: 0,
    startEntryCountPhoto: 0,
    endEntryCountPhoto: 0,
    startExitCount: 0,
    startExitCountPhoto: '',
    endExitCount: 0,
    endExitCountPhoto: '',
    createdAt: '',
    updatedAt: '',
    transportOperatorId: '',
    seccionedNeeded: null,
  },
  tripList: [],
  tripListFull: [],
  tripDetailsList: [],
  tripReportHtml: '',
  tripReport: [],
  kmType: '',
  monitoringSettingsList: [],
  totalCount: 0,
  error: false,
  loading: false,
  loadingTripDetails: false,
};

const reducer: Reducer<TripsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LIST_TRIPS_DETAIL
    case TripTypes.LIST_TRIPS_DETAIL_REQUEST:
      return {
        ...state,
        loadingTripDetails: true,
        error: false,
        tripDetailsList: INITIAL_STATE.tripDetailsList,
      };
    case TripTypes.LIST_TRIPS_DETAIL_SUCCESS:
      return {
        ...state,
        loadingTripDetails: false,
        error: false,
        tripDetailsList: action.payload.tripDetailsList,
        totalCount: action.payload.totalCount,
      };
    case TripTypes.LIST_TRIPS_DETAIL_FAILURE:
      return {
        ...state,
        loadingTripDetails: false,
        error: true,
        tripDetailsList: INITIAL_STATE.tripDetailsList,
      };

    // CASES LIST_TRIPS
    case TripTypes.LIST_TRIPS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        ...(!action.payload?.isCsvFull && {
          tripList: INITIAL_STATE.tripList,
        }),
      };
    case TripTypes.LIST_TRIPS_SUCCESS:
      return {
        ...state,
        loading: action.payload.loading || false,
        error: false,
        ...(!action.payload?.isCsvFull && {
          tripList: action.payload.tripList,
        }),
        ...(action.payload?.isCsvFull && {
          tripListFull: action.payload.tripList,
        }),
        totalCount: action.payload.totalCount,
      };
    case TripTypes.LIST_TRIPS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        tripList: INITIAL_STATE.tripList,
      };

    // CASES LIST_TRIPS
    case TripTypes.GET_TRIPS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        tripData: INITIAL_STATE.tripData,
      };
    case TripTypes.GET_TRIPS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        tripData: action.payload.tripData,
      };
    case TripTypes.GET_TRIPS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        tripData: INITIAL_STATE.tripData,
      };

    // CASES TRIP HTML REPORT
    case TripTypes.TRIP_REPORT_HTML_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        tripReportHtml: INITIAL_STATE.tripReportHtml,
      };

    case TripTypes.TRIP_REPORT_HTML_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        tripReportHtml: action.payload.tripReportHtml,
      };

    case TripTypes.TRIP_REPORT_HTML_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        tripReportHtml: INITIAL_STATE.tripReportHtml,
      };

    // CASES TRIP REPORT
    case TripTypes.TRIP_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        tripReport: INITIAL_STATE.tripReport,
      };

    case TripTypes.TRIP_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        tripReport: action.payload.tripReport,
      };

    case TripTypes.TRIP_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        tripReport: INITIAL_STATE.tripReport,
      };

    case TripTypes.CHANGE_KM_TYPE:
      return {
        ...state,
        loading: false,
        error: false,
        kmType: action.payload.kmType,
      };

    // CASES TRIP UPDATE CONTROL
    case TripTypes.TRIP_UPDATE_CONTROL_REQUEST:
      return { ...state, loading: true, error: false };
    case TripTypes.TRIP_UPDATE_CONTROL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        tripReportControl: action.payload.tripReportControl,
      };
    case TripTypes.TRIP_UPDATE_CONTROL_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES TRIPCONTROL SETTINGS
    case TripTypes.TRIP_CONTROL_SETTINGS_REQUEST:
      return { ...state, loading: true, error: false };
    case TripTypes.TRIP_CONTROL_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        tripControlSettingsData: action.payload.tripControlSettingsData,
      };
    case TripTypes.TRIP_CONTROL_SETTINGS_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES TRIPCONTROL SETTINGS UPDATE
    case TripTypes.TRIP_CONTROL_SETTINGS_UPDATE_REQUEST:
      return { ...state, loading: true, error: false };
    case TripTypes.TRIP_CONTROL_SETTINGS_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        tripControlSettingsData: action.payload.tripControlSettingsData,
      };
    case TripTypes.TRIP_CONTROL_SETTINGS_UPDATE_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES MONITORING SETTINGS LIST
    case TripTypes.MONITORING_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        monitoringSettingsList: INITIAL_STATE.monitoringSettingsList,
      };
    case TripTypes.MONITORING_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        monitoringSettingsList: action.payload.monitoringSettingsList,
      };
    case TripTypes.MONITORING_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        monitoringSettingsList: INITIAL_STATE.monitoringSettingsList,
      };
    // CASES MONITORING SETTINGS UPDATE
    case TripTypes.MONITORING_SETTINGS_UPDATE_REQUEST:
      return { ...state, loading: true, error: false };
    case TripTypes.MONITORING_SETTINGS_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        monitoringSettingsList: INITIAL_STATE.monitoringSettingsList,
      };
    case TripTypes.MONITORING_SETTINGS_UPDATE_FAILURE:
      return { ...state, loading: false, error: true };

    default:
      return state;
  }
};

export default reducer;
